import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import { parseRawTableNoTLV } from '../utils/store.table-no'
import { getStorefrontStorageKey } from '@/common/storefront/storefront.config'

export interface StoreItem {
  address: string
  close_time: string
  distance: string
  feature_image: string
  id: number | string
  menu_code: string
  name: string
  open_time: string
  phoneNumber: string
  storeNo: string
  location: {
    lat: number
    lng: number
  }
  original_data: {
    isOpen?: "Open" | "Off"
    closeTimeDisplay?: string
    [key: string]: any
  }
  [key: string]: any
}

type Store = {
  store: StoreItem | null
  table_no?: {
    original: string
    formatted: {
      floor: string
      zone: string
      table: string
      version: string
      [key: string]: string
    }
  }
  setStore: (store: StoreItem) => void
  resetStore: () => void
  setTableNo: (table_no: string) => void
}

export const useStoreStore = create<Store>()(
  persist(
    (set, get) => ({
      store: null,
      setStore: (store) => set({ store }),
      setTableNo: (table_no: string) => {
        const formatted = parseRawTableNoTLV(table_no) as {
          floor: string
          zone: string
          table: string
          version: string
          [key: string]: string
        }
        
        set({
          table_no: {
            original: table_no,
            formatted,
          },
        })
      },
      resetStore: () => set({ store: null }),
    }),
    {
      name: getStorefrontStorageKey('store-storage'),
      storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
    },
  ),
)
